import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"

import LightLogo from "../images/sparkle-logo-black.png"
import LogoMark from "../images/sparkle-footer-logo-mark.png"
import Appstore from "../images/Appstore.png"
import Googlestore from "../images/Googleplay.png"
import Pattern from "../images/app-pattern.png"

function Footer(props) {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          appStoreLink
          playStoreLink
        }
      }
    }
  `)

  return (
    <>
      {!props.visible && (
        <div className="container py-lg-5 py-4">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center position-relative">
              <div className="appdownload--wrapper p-4 py-lg-5" id="download">
                <h2 className="text-white sparkle--font__36 sparkle--mont__900 mt-4">
                  Be Part of Our Sparkle Tribe
                </h2>
                <p className="mt-4 mb-5 text-white">
                  Download the Sparkle App and open an account within minutes
                </p>

                <ul className="list-inline my-4">
                  <li className="list-inline-item mx-3 my-3">
                    <a href={data.site.siteMetadata.appStoreLink}>
                      <img
                        src={Appstore}
                        alt="Download sparkle on applestore"
                        className="img-fluid"
                        width="170"
                      />
                    </a>
                  </li>

                  <li className="list-inline-item mx-3 my-3">
                    <a href={data.site.siteMetadata.playStoreLink}>
                      <img
                        src={Googlestore}
                        alt="Download sparkle on google play store"
                        className="img-fluid"
                        width="170"
                      />
                    </a>
                  </li>
                </ul>
                <img
                  src={Pattern}
                  alt="abstract pattern"
                  className="img-fluid position-absolute pattern1 d-none d-lg-block"
                />
                <img
                  src={Pattern}
                  alt="abstract pattern"
                  className="img-fluid position-absolute pattern2 d-none d-lg-block"
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {!props.footerVisible && (
        <footer className="pt-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 my-3 my-lg-1">
                <Link to="/">
                  <img
                    src={LightLogo}
                    className="img-fluid"
                    alt="Sparkle Nigeria"
                    width="200"
                  />
                </Link>
                <p className="footer__description mt-3">
                  A lifestyle and payment ecosystem that intersects your
                  personal and business financial needs
                </p>
              </div>
              <div className="col-lg-2 my-3">
                <h5 className="footer__title">Product</h5>
                <ul className="list-unstyled">
                  <li className="my-4">
                    <Link to="/" activeClassName="active">
                      Personal
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/business" activeClassName="active">
                      Business
                    </Link>
                  </li>
                  {/* <li className="my-4">
                      <Link to="/kids" activeClassName="active">
                        Kids
                      </Link>
                    </li> */}
                </ul>
              </div>

              <div className="col-lg-2 col-6 my-3 my-lg-1">
                <h5 className="footer__title">Features</h5>
                <ul className="list-unstyled">
                  <li className="my-4">
                    <Link to="/features/sparklepay" activeClassName="active">
                      {" "}
                      SparklePay
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/sparkle-cards" activeClassName="active">
                      Cards
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/indy" activeClassName="active">
                      Indy
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/stash" activeClassName="active">
                      Stash
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/breakdown" activeClassName="active">
                      Breakdown
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link
                      to="/features/invoice-and-inventory"
                      activeClassName="active"
                    >
                      Inventory
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link
                      to="/features/invoice-and-inventory"
                      activeClassName="active"
                    >
                      Invoice
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/split-payment" activeClassName="active">
                      Tabs
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/sparkle-loan/" activeClassName="active">
                      Loans
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-6 my-3 my-lg-1">
                <span className="footer__title">&nbsp;</span>
                <ul className="list-unstyled">
                  {/* <li className="my-4">
                        <Link
                          to="/features/month-in-view"
                          activeClassName="active"
                        >
                          Month in View
                        </Link>
                      </li> */}
                  <li className="my-4">
                    <Link to="/features/payment" activeClassName="active">
                      Payments
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link
                      to="/features/sparkle-loyalty"
                      activeClassName="active"
                    >
                      Loyalty
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/split-payment" activeClassName="active">
                      Split Bills
                    </Link>
                  </li>
                  {/* <li className="my-4">
                      <Link to="/features/investments" activeClassName="active">
                        Investments
                      </Link>
                    </li> */}
                  <li className="my-4">
                    <Link to="/features/taxation" activeClassName="active">
                      Taxation
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/features/payroll" activeClassName="active">
                      Payroll
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link
                      to="/sparkle-business-support"
                      activeClassName="active"
                    >
                      Business Support{" "}
                    </Link>
                  </li>
                  {/* <li className="my-4">
                      <Link to="/documentation" activeClassName="active">
                        Documentations
                      </Link>
                    </li> */}
                </ul>
              </div>

              <div className="col-lg-2 col-6 my-3 my-lg-1">
                <h5 className="footer__title">Sparkle</h5>
                <ul className="list-unstyled">
                  <li className="my-4">
                    <Link to="/about-us" activeClassName="active">
                      About Us
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/leadership" activeClassName="active">
                      Leadership
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/community" activeClassName="active">
                      Community
                    </Link>
                  </li>
                  <li className="my-4">
                    <Link to="/blog" activeClassName="active">
                      Blog
                    </Link>
                  </li>

                  <li className="my-4">
                    <Link to="/careers" activeClassName="active">
                      Careers
                    </Link>
                  </li>

                  <li className="my-4">
                    <Link to="/legal" activeClassName="active">
                      Legal
                    </Link>
                  </li>

                  <li className="my-4">
                    <Link to="/contact-us" activeClassName="active">
                      Contact Us
                    </Link>
                  </li>

                  <li className="my-4">
                    <a
                      href="https://store.sparkle.ng"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Merchandise Store
                    </a>
                  </li>

                  <li className="my-4">
                    <a
                      href="https://sparkleng.statuspage.io/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Platform Status
                    </a>
                  </li>

                  <li className="my-4">
                    <Link to="/pacelli" activeClassName="active">
                      Donate to Pacelli School of the blind
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-1 col-6 my-3 my-lg-1">
                <h5 className="footer__title">Follow</h5>
                <ul className="list-unstyled">
                  <li className="my-4">
                    <a
                      href="https://www.facebook.com/sparkleplaceng"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li className="my-4">
                    <a
                      href="https://www.instagram.com/sparklenigeria/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                  <li className="my-4">
                    <a
                      href="https://www.linkedin.com/company/sparkle-nigeria/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Linkedin
                    </a>
                  </li>
                  <li className="my-4">
                    <a
                      href="https://twitter.com/sparkle_nigeria"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      Twitter
                    </a>
                  </li>
                  <li className="my-4">
                    <a
                      href="https://www.youtube.com/channel/UCJjqjOITepojplnYOhplbBw"
                      target="_blank"
                      rel="noreferrer"
                    >
                      YouTube
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <img
                  src={LogoMark}
                  className="img-fluid"
                  alt="Sparkle Nigeria"
                  width="100"
                />
                <p className="footer__disclaimer mb-3">
                  © {new Date().getFullYear()} Sparkle Microfinance Bank
                  (RC1589808). All rights reserved. All deposits are insured by
                  the Nigerian Deposit Insurance Corporation (NDIC). Sparkle
                  Microfinance Bank is licensed by the Central Bank of Nigeria.
                </p>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  )
}

export default Footer
